import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { format, parseISO } from "date-fns";
import {
  danger,
  success,
  showLoading,
} from "../../../components/show-notification";
import api from "../../../providers/api";
import LoadingPanel from "../../../components/loading-painel";
import draftToHtml from 'draftjs-to-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import Layout from "../../../layout";
import validateCadastrar from "./form-validate-cadastrar";
import validateEditar from "./form-validate-editar";

const CatalogoCadastrar = () => {
  const location = useLocation();
  const history = useHistory();
  const [state, setState] = useState({
    id: 0,
    titulo: "",
    descricao: "",
    titulo_in: "",
    descricao_in: "",
    titulo_es: "",
    descricao_es: "",
    url_imagem: "",
    url_manual: ""
  });

  let preencherValoresEdits = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const enviarFormulario = async (e) => {
    e.preventDefault();

    if (!window.$("#form-catalogo").valid()) {
      return;
    }

    try {
      const formData = new FormData();

      formData.append("id", state.id);
      formData.append("url_imagem", state.url_imagem);
      formData.append("url_manual", state.url_manual);

      formData.append("titulo", state.titulo);
      formData.append("descricao", state.descricao);

      formData.append("titulo_in", state.titulo_in);
      formData.append("descricao_in", state.descricao_in);

      formData.append("titulo_es", state.titulo_es);
      formData.append("descricao_es", state.descricao_es);

      const enviar = state.id > 0 ? api.put : api.post;

      const requisicao = await enviar("/manuais", formData);

      const { data } = requisicao;

      if (!data.status) {
        danger(data.mensagem);
        return;
      }

      if (!data.data) {
        return;
      }

      success(data.mensagem);
      history.push("/manuais");
    } catch (error) {
      console.log(error);
      danger("Erro ao cadastrar o catálogo.");
    }
  };

  useEffect(() => {
    // window.$("#summernote").summernote({
    //   height: window.innerHeight - window.innerHeight / 3
    // });
    // window.$("#summernote_in").summernote({
    //   height: window.innerHeight - window.innerHeight / 3
    // });
    // window.$("#summernote_es").summernote({
    //   height: window.innerHeight - window.innerHeight / 3
    // });
  }, []);

  useEffect(() => {
    const carregarDados = async () => {
      if (!location.state) {
        return;
      }

      try {
        showLoading(".ibox-content");

        const requisicao = await api.get(`/manuais/${location.state.id}`);

        const { data } = requisicao;

        if (!data.status) {
          danger(data.mensagem);
          return;
        }

        if (!data.data) {
          return;
        }

        data.data.data = data.data.data_iso;

        setState(data.data);
        // window.$("#summernote").summernote("code", data.data.descricao);
        // window.$("#summernote_in").summernote("code", data.data.descricao_in);
        // window.$("#summernote_es").summernote("code", data.data.descricao_es);
        showLoading(".ibox-content");
      } catch (error) {
        console.log(error);
        showLoading(".ibox-content");
        danger("Erro ao carregar os dados do catálogo");
      }
    };

    let validacao = window
      .$("#form-catalogo")
      .validate(!location.state ? validateCadastrar : validateEditar);

    carregarDados();

    return () => validacao.destroy();
  }, [location.state]);

  return (
    <>
      <Layout
        titulo="Ibraflex - Catálogos"
        header="Cadastro do Catálogo"
        action={{ titulo: "Voltar", link: "/manuais" }}
      >
    
        <div className="ibox-content">
            <LoadingPanel />
            <div className="row">
                <div className="col-lg-12">
               
                        <div className="ibox ">
                            <div className="ibox-title">
                                <h5>Dados do catálogo</h5>
                            </div>
                            <div className="ibox-content">
                                <LoadingPanel />
                                <div className="row">
                                <div className="col-lg-12">
                                    <form id="form-catalogo">
                                        <div className="row">
                                            <div className="col-lg-6">
                                              <div className="form-group">
                                                  <label>Imagem do catálogo</label>
                                                  <input
                                                  type="file"
                                                  placeholder="Imagem do catálogo"
                                                  className="form-control"
                                                  name="url_imagem"
                                                  accept="image/*"
                                                  onChange={(e) =>
                                                      setState({
                                                      ...state,
                                                      url_imagem: e.target.files[0],
                                                      })
                                                  }
                                                  />
                                              </div>
                                            </div>

                                            <div className="col-lg-6">
                                              <div className="form-group">
                                                  <label>Arquivo do catálogo</label>
                                                  <input
                                                  type="file"
                                                  placeholder="Arquivo do catálogo"
                                                  className="form-control"
                                                  name="url_manual"
                                                  accept="application/pdf"
                                                  onChange={(e) =>
                                                      setState({
                                                      ...state,
                                                      url_manual: e.target.files[0],
                                                      })
                                                  }
                                                  />
                                              </div>
                                            </div>

                                            
                                          
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-12">
                                            <div className="form-group">
                                                <div class="tabs-container">
                                                <ul class="nav nav-tabs" role="tablist">
                                                    <li>
                                                    <a
                                                        class="nav-link active"
                                                        data-toggle="tab"
                                                        href="#tab-1"
                                                    >
                                                        Português
                                                    </a>
                                                    </li>
                                                    <li>
                                                    <a
                                                        class="nav-link"
                                                        data-toggle="tab"
                                                        href="#tab-2"
                                                    >
                                                        Inglês
                                                    </a>
                                                    </li>
                                                    <li>
                                                    <a
                                                        class="nav-link"
                                                        data-toggle="tab"
                                                        href="#tab-3"
                                                    >
                                                        Espanhol
                                                    </a>
                                                    </li>
                                                </ul>
                                                <div class="tab-content">
                                                    <div
                                                    role="tabpanel"
                                                    id="tab-1"
                                                    class="tab-pane active"
                                                    >
                                                    <div class="panel-body">
                                                        <div className="row">
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                            <label>Título do catálogo</label>
                                                            <input
                                                                type="text"
                                                                placeholder="Título do catálogo"
                                                                className="form-control"
                                                                name="titulo"
                                                                value={state.titulo}
                                                                onChange={(e) =>
                                                                preencherValoresEdits(e)
                                                                }
                                                            />
                                                            </div>
                                                        </div>
                                                        </div>
                                                        <div className="row">
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                            <label>Descrição do catálogo</label>
                                                            <textarea
                                                                type="text"
                                                                placeholder="Descrição do catálogo"
                                                                className="form-control"
                                                                name="descricao"
                                                                value={state.descricao}
                                                                onChange={(e) =>
                                                                preencherValoresEdits(e)
                                                                }
                                                                rows={3}
                                                            />
                                                          </div>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    </div>
                                                    <div
                                                    role="tabpanel"
                                                    id="tab-2"
                                                    class="tab-pane"
                                                    >
                                                    <div class="panel-body">
                                                        <div className="row">
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                            <label>Título do catálogo</label>
                                                            <input
                                                                type="text"
                                                                placeholder="Título do catálogo"
                                                                className="form-control"
                                                                name="titulo_in"
                                                                value={state.titulo_in}
                                                                onChange={(e) =>
                                                                preencherValoresEdits(e)
                                                                }
                                                            />
                                                            </div>
                                                        </div>
                                                        </div>
                                                        <div className="row">
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                            <label>Descrição do catálogo</label>
                                                            <textarea
                                                            rows={3}
                                                                type="text"
                                                                placeholder="Descrição do catálogo"
                                                                className="form-control"
                                                                name="descricao_in"
                                                                value={state.descricao_in}
                                                                onChange={(e) =>
                                                                preencherValoresEdits(e)
                                                                }
                                                            />
                                                            
                                                            
                                                            </div>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    </div>
                                                    <div
                                                    role="tabpanel"
                                                    id="tab-3"
                                                    class="tab-pane"
                                                    >
                                                    <div class="panel-body">
                                                        <div className="row">
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                            <label>Título do catálogo</label>
                                                            <input
                                                                type="text"
                                                                placeholder="Título do catálogo"
                                                                className="form-control"
                                                                name="titulo_es"
                                                                value={state.titulo_es}
                                                                onChange={(e) =>
                                                                preencherValoresEdits(e)
                                                                }
                                                            />
                                                            </div>
                                                        </div>
                                                        </div>
                                                        <div className="row">
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                            <label>Descrição do catálogo</label>
                                                            
                                                            <textarea
                                                            rows={3}
                                                                type="text"
                                                                placeholder="Descrição do catálogo"
                                                                className="form-control"
                                                                name="descricao_es"
                                                                value={state.descricao_es}
                                                                onChange={(e) =>
                                                                preencherValoresEdits(e)
                                                                }
                                                            />                                                      </div>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        <div>
                                            <button
                                            className="btn btn-sm btn-success float-right m-t-n-xs"
                                            type="submit"
                                            onClick={(e) => enviarFormulario(e)}
                                            >
                                            <strong>Salvar</strong>
                                            </button>
                                        </div>
                                    </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    
                
                </div>
            </div>
        </div>
            
      </Layout>
    </>
  );
};

export default CatalogoCadastrar;
